import { useCallback } from 'react';

import { useTelephonyCti } from '@/contexts/TelephonyCtiContext';
import { useTelephonyProvider } from '@/hooks/useTelephonyProvider';

import { DialpadMiniDialerDrawer } from '../dialpad/DialpadMiniDialerDrawer';
import { RingCentralMiniDialerDrawer } from './RingCentralMiniDialerDrawer';

export const TelephonyMiniDialerHost = () => {
  const { isPanelOpen, setPanelOpen } = useTelephonyCti();
  const { isRingCentral } = useTelephonyProvider();

  const handleOpenChange = useCallback(
    (open: boolean) => {
      setPanelOpen(open);
    },
    [setPanelOpen],
  );

  if (isRingCentral) {
    return (
      <RingCentralMiniDialerDrawer
        open={isPanelOpen}
        onOpenChange={handleOpenChange}
      />
    );
  }

  return (
    <DialpadMiniDialerDrawer
      open={isPanelOpen}
      onOpenChange={handleOpenChange}
    />
  );
};
